// Option B — cut by dimension of identity. 5 flat SELF pages, each answers one question.
// Keep this in sync with SELF_SLUGS in api/src/controllers/brain.js.

export const SELF_PAGES = [
  {
    slug: "culture",
    title: "Culture",
    description: "How it's actually like to work here — pace, autonomy, comms, fail tolerance.",
    placeholder: `## How decisions get made
- Consensus or top-down? Async or sync?

## Pace & autonomy
- Sprints or calm? Proactive or reactive expected?

## Communication norms
- Slack-heavy / docs-heavy / meeting-heavy?

## Failure tolerance
- What happens when something breaks?
`,
  },
  {
    slug: "ideal-candidate",
    title: "Ideal candidate",
    description: "Traits that thrive here, anti-traits, green & red flags.",
    placeholder: `## Traits that thrive
- e.g. low-ego, owner mindset, ships over perfect

## Anti-traits
- e.g. gatekeepers, perfectionists who can't ship

## Green flags
- e.g. open-source contributions, side projects, early-stage experience

## Red flags
- e.g. job-hopping pattern, comp-only motivation
`,
  },
  {
    slug: "process",
    title: "Process",
    description: "How we hire — rounds, formats, gates, tests, deal-breakers.",
    placeholder: `## Rounds
- Round 1: ...
- Round 2: ...

## What we evaluate at each step
- ...

## What we won't do
- e.g. takehome > 4h, comp-anchor before R2

## Deal-breakers
- ...
`,
  },
  {
    slug: "tone",
    title: "Tone",
    description: "Voice with candidates — outreach, rejection, follow-up.",
    placeholder: `## General voice
- Direct / formal / chatty?

## Outreach style
- Cold approach, warm intro, sourcing follow-up

## Rejection style
- How honest? How fast? What we share.

## Do / Don't
- Words and phrases that sound like us / not like us
`,
  },
  {
    slug: "offer",
    title: "Offer",
    description: "What we propose — comp stance, remote, perks, career narrative.",
    placeholder: `## Compensation
- Transparent up-front? Range? Equity philosophy?

## Remote / hybrid
- Policy + reality

## Perks worth mentioning
- ...

## Career narrative
- What growth looks like here
`,
  },
];

export function getSelfPage(slug) {
  return SELF_PAGES.find((p) => p.slug === slug);
}
